<script>
import { Pie } from 'vue-chartjs';
import { COLORS } from './pie-chart-colors';

export default {
  extends: Pie,
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    render() {
      this.renderChart(
        {
          labels: this.data.labels,
          datasets: [
            {
              data: this.data.values,
              backgroundColor: COLORS,
            },
          ],
        },
        {
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 20,
              bottom: 20,
            },
          },
          legend: {
            display: false,
            position: 'right',
            labels: {
              usePointStyle: false,
              boxWidth: 20,
              padding: 15,
              fontSize: 14,
            },
          },
          tooltips: false,
          maintainAspectRatio: true,
          responsive: true,
        }
      );
    },
  },
  watch: {
    data() {
      this.render();
    },
  },
  mounted() {
    this.render();
  },
};
</script>
